import React from 'react';
import './RasMaxAmount.scss';
import { getRasDailyMax } from '../../../utils/advice/advice-utility';
import { openModal } from '../../../redux/modules/modals/actions';
import {
  MIN_MAX_FINANCIAL_ADVISOR_MODAL,
  RAS_WITHDRAW_THRESHOLD_MODAL,
} from '../../../redux/modules/modals/modals.module';
import { useDispatch, useSelector } from 'react-redux';
import InfoIcon from '../../../assets/images/icon_info.svg';
import { currency } from '../../../utils/utils';
import { getSellPendingTransactions } from '../../../redux/modules/pendingTransactions/pendingTransactions.selectors';

const RasMaxAmount = ({ fund }) => {
  const dispatch = useDispatch();
  const sellPendingTransactions = useSelector(getSellPendingTransactions);
  const withdrawMax = fund.grossAmountDollars
    ? getRasDailyMax(fund, sellPendingTransactions) - fund.grossAmountDollars
    : getRasDailyMax(fund, sellPendingTransactions);
  return (
    <div className="ras-max-amount-container">
      <h3>
        Withdraw Limit
        <img
          src={InfoIcon}
          onClick={() => dispatch(openModal(RAS_WITHDRAW_THRESHOLD_MODAL))}
          alt="RAS Withdraw Max Information"
        />
      </h3>
      <div className="ras-max-amount-section">
        {withdrawMax < 0 ? (
          <span className="negative-amount">{currency(withdrawMax)}</span>
        ) : (
          <span className="positive-amount">{currency(withdrawMax)}</span>
        )}
      </div>
      <div className="contact-advisor-link">
        <a
          onClick={() =>
            dispatch(openModal(MIN_MAX_FINANCIAL_ADVISOR_MODAL, { fund }))
          }
        >
          Contact your advisor for additional needs.
        </a>
      </div>
    </div>
  );
};

export default RasMaxAmount;
